import { render } from "./EmailsSection.vue?vue&type=template&id=79ebb178"
import script from "./EmailsSection.vue?vue&type=script&lang=js"
export * from "./EmailsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__